import { RECRUITERCLIENTPRIMARY } from "../../ENVIRONMENT";

// api for recruiter primary list
function recprimaryList(token) {
  const response = fetch(RECRUITERCLIENTPRIMARY, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
  return response;
}

export { recprimaryList };
